module.exports = __webpack_public_path__ + "6b455d4bc7a95f18dd7c8c1ed7a57dee.svg";